// extracted by mini-css-extract-plugin
export default {"landing-page-card":"ResponsiveNavbar_landing-page-card__3+gKs","footerNav":"ResponsiveNavbar_footerNav__pbtZ3","whiteLogo":"ResponsiveNavbar_whiteLogo__Di9NW"};